module.exports = __webpack_public_path__ + "img/illust.fc24b239.svg";